/**
 * Utility function to get localized text from bilingual content
 * 
 * @param item - Object with bilingual fields (e.g., MenuItem with name, nameAr, description, descriptionAr)
 * @param field - Base field name (e.g., 'name', 'description')
 * @param language - Current language ('ar' | 'en')
 * @returns Localized text, falling back to base field if localized version is missing
 * 
 * @example
 * const menuItem = { name: 'Pizza', nameAr: 'بيتزا', description: 'Delicious pizza', descriptionAr: 'بيتزا لذيذة' }
 * getLocalizedText(menuItem, 'name', 'ar') // Returns 'بيتزا'
 * getLocalizedText(menuItem, 'name', 'en') // Returns 'Pizza'
 * getLocalizedText(menuItem, 'name', 'ar') // Falls back to 'Pizza' if nameAr is null/undefined
 */
export function getLocalizedText(
  item: any,
  field: string,
  language: 'ar' | 'en'
): string {
  if (!item) {
    return ''
  }

  // For Arabic, try the Arabic field first (field + 'Ar'), then fall back to base field
  if (language === 'ar') {
    const arabicField = `${field}Ar`
    const arabicValue = (item as Record<string, unknown>)[arabicField]
    
    // Return Arabic value if it exists and is not empty
    if (arabicValue !== null && arabicValue !== undefined && String(arabicValue).trim() !== '') {
      return String(arabicValue)
    }
    
    // Fall back to base field
    const baseValue = (item as Record<string, unknown>)[field]
    return baseValue !== null && baseValue !== undefined ? String(baseValue) : ''
  }

  // For English, use base field
  const baseValue = (item as Record<string, unknown>)[field]
  return baseValue !== null && baseValue !== undefined ? String(baseValue) : ''
}


